<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g;
import SocialLoginCard from "../SocialLoginCard/SocialLoginCard.svelte";
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore, getHrefForMediaItem } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { Popup, Link } from 'framework7-svelte';
import { onMount } from 'svelte';
import { f7 } from 'framework7-svelte';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { getContext } from 'svelte';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { ycSSOSetState } from '../../../../../js/ycapp';
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: clientConfig = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.clientConfig) || {};
$: nextPage = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.nextPage) || undefined;
$: nextPageExistingAccount = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.nextPageExistingAccount) || undefined;
$: endWorkflowExistingAccount = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.endWorkflowExistingAccount) || undefined;
$: useSportsAllianceLogin = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.useSportsAllianceLogin) || false;
$: showLoginText = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.showLoginText) || false;
$: endWorkflow = (_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.endWorkflow;
function afterConnect(existingAccount) {
    if (existingAccount && nextPageExistingAccount) {
        resolveUrl(nextPageExistingAccount).func();
    }
    else if (endWorkflow || (existingAccount && endWorkflowExistingAccount)) {
        signonManager.fireWorkflowEndEvent();
    }
    else if (nextPage) {
        resolveUrl(nextPage).func();
    }
    else if (signonManager.skipCompleteProfilePage) {
        resolveUrl(`ConnectAccounts`).func();
    }
    else {
        resolveUrl(`CompleteProfile`).func();
    }
}
const onConnect = () => {
    ycSSOThirdPartyAuth("FACEBOOK", clientConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        console.log("ycSSOThirdPartyAuth callback inside FACEBOOK", method, clientResult);
        if (!(clientResult === null || clientResult === void 0 ? void 0 : clientResult.authenticationToken) && !(clientResult === null || clientResult === void 0 ? void 0 : clientResult.accessToken)) {
            console.warn(`ycSSOThirdPartyAuth callback for ${method}: no access token in client result`);
            signonManager.fireWorkflowEndEvent();
            return;
        }
        // authenticationToken is a JWT that is the newer recommended thing
        // iOS supports authenticationToken as of Jan 2025, but Android does not
        // for the socialToken, we take the authenticationToken if available, otherwise fall back to accessToken
        const socialToken = (clientResult === null || clientResult === void 0 ? void 0 : clientResult.authenticationToken) || (clientResult === null || clientResult === void 0 ? void 0 : clientResult.accessToken);
        let result;
        f7.preloader.show('white');
        try {
            if (useSportsAllianceLogin) {
                result = yield signonManager.loginWithSportsAllianceSocialAccount('Facebook', socialToken);
            }
            else {
                result = yield signonManager.loginWithFacebookAccount(socialToken);
            }
        }
        finally {
            f7.preloader.hide();
        }
        if (result.success) {
            const existingAccount = result.data.AccountCreated !== 'true';
            ycSSOSetState(!existingAccount, result.data.YinzId, parseInt(result.data.ValidSpan), result.data.Ticket);
            afterConnect(existingAccount);
        }
        else {
            alert(((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.UserMessage) === null || _b === void 0 ? void 0 : _b.Content) || 'An error occurred.');
            signonManager.fireWorkflowEndEvent();
        }
    }));
};
</script>

<CardBase {element}>
    <SocialLoginCard 
        label={(showLoginText)? 'Sign in with Facebook' : ''}
        image={'/static/icons/icon-facebook-logo-only.png'}
        backgroundColor="#1877F2"
        textColor="white"
        borderColor="#1877F2"
        onConnect={onConnect}
        {sources}
    />
</CardBase>